export default __webpack_public_path__ + "static/media/Damages.a23897b7.svg";